var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mapContinent",staticClass:"map-continent",class:{ 'map-continent--active': _vm.currentRegion === _vm.region.code },style:({ 
    left: _vm.region.leftMVw + 'px', 
    top: _vm.region.topMVw + 'px',
    transform: `scale(${_vm.scale }) translate(-50%, -50%)`
  }),on:{"click":function($event){return _vm.$emit('click:title', _vm.region)}}},[(_vm.region.items && _vm.computedItems.length)?_c('div',{staticClass:"map-continent__counter"},[_c('a',{staticClass:"map-continent__counter-anchor"},[_vm._v(" "+_vm._s(_vm.computedItems.length)+" ")])]):_vm._e(),_c('div',{staticClass:"map-continent__name",style:({ 
      'max-width': _vm.region.maxNameWidth ? `${_vm.region.maxNameWidth}px` : 'none',
    })},[_c('a',{staticClass:"map-continent__name-anchor"},[_vm._v(" "+_vm._s(_vm.region.name)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }